<template>
  <div style="height: 100%">
    <fdc-panel
      title="Grid에 기본 컴포넌트 사용"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 70%;"
        id="cellDefaultComponent"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"

        :pagination="true"
        :brique-grid-is-view-pagination="false"
        :brique-grid-is-view-cud-count="true"
        :brique-grid-is-view-total-count="true"
        :brique-grid-is-view-selected-count="true"

        :brique-grid-is-view-header="true"
        :brique-grid-refresh-function="refreshData"
        :brique-grid-is-view-add-row-btn="true"
        :brique-grid-is-view-remove-row-btn="true"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'CellDefaultComponent',
  components: {
    'monaco-editor': MonacoEditor
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data.slice(0, 20).map(d => {
          if (d.total > 5) {
            d.totalOver = 'Y'
            d.totalFiveOver = true
          } else {
            d.totalOver = 'N'
            d.totalFiveOver = false
          }
          d.imageSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACAUlEQVRIibXVTYiNYRQH8N+9cyeahsHOzGJCKY0rGRuJZuFjQ2rSrKRkEpGaTMlI2VgoH0tZDysLCQvfH5FESmxmY1YzI9+DZIqyeM80r+ve970j/nXqec/5n+f/PG/nnKcgG7PRkMP5ic85nKo4jXF8yLFxnPobgfvoTH0XsTCsmPJ3BrcqirUCVdCFG2Fd9SaVpiFwG4umwcf0bvDPMA9bMIx76M/g9gfnFTahJW/zA3iHCziCHoxgSRVuR8R6cBQX8R4HswQGsRXtWIdy3GYE61O8jRiNUy8NbnvkDuYJfMcQ7uJB+FfjMT6FPcKqiD0M7lDk5gp0x7ok+V2tqfiMsEm04a2pauyuFMiqoh84h96UbyJsEr04H9yqyOuD43iKS3heEVuOXViZtUGewBi24wpO4BoK2CAp0W3BqYl6Gu0W1mKxZExcj/Ua3MlLrndUDGOvpDThWJ15/39UpAUK6mj1OtASe/0hcBib1X7BmjA/rKkGpyH2OFQZKOM1BiTdmxZehsuSarkZNiYp3XKKV4zcgdirIy1wFvtifRV9sd6JN9iNxhS/EXsitiN8fZEL+3GGqX81Jnn6RiXt/wxfsQAfJfOnGuZgrqTKmrFCMhjb8AStpThNC16mEpvjNJldmsJJSdO9SPlmojR5gya/DzH4ImPGVKCEWRW+CXz7BZihbZ9S0CN0AAAAAElFTkSuQmCC'
          d.date = d.date.split('/').reverse().join('/') // date format이 DD/MM/YYYY 여서 converting함
          return d
        })))
    },
    cellButtonClicked (params) {
      const item = params.data
      this.$dialog.alert(JSON.stringify(item, null, '\t'))
    }
  },
  data: function () {
    let self = this
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { field: 'athlete', minWidth: 150, checkboxSelection: true },
        { field: 'age', maxWidth: 90, editable: true, type: 'numericColumn' },
        { field: 'year', maxWidth: 90, editable: true, type: 'numericColumn' },
        { field: 'date', minWidth: 150, editable: true, type: 'dateColumn', dateFormat: 'YYYY-MM-DD' },
        { field: 'sport', minWidth: 150 },
        {
          headerName: 'Country (Combo List)',
          field: 'country',
          minWidth: 150,
          editable: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: {
            values: ['United States', 'Russia', 'Australia', 'Canada', 'China']
          },
          pinned: 'right'
        }, // Combo List
        {
          headerName: 'Button (Button Render)',
          field: 'button',
          width: 150,
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            clicked: function (params) {
              self.cellButtonClicked(params)
            }, // button click event 설정
            btnType: 'is-light',
            btnIcon: 'cursor-default-click', // button icon 설정
            btnTitle: 'Button Render', // button title 설정
            btnStyle: 'height: 20px;', // button 추가 style 설정
            btnLabel: 'Button Render' // button text 설정
          },
          pinned: 'right'
        }, // Button
        {
          headerName: 'Total Five Over (Check Box)',
          field: 'totalFiveOver',
          type: 'checkboxColumn',
          dataMapping: {
            key: 'totalOver',
            true: 'Y',
            false: 'N'
          },
          pinned: 'right'
        }, // Check Box
        {
          headerName: 'Total Five Over (Radio Button)',
          field: 'totalFiveOver',
          type: 'radioButtonColumn',
          dataMapping: {
            key: 'totalOver',
            true: 'Y',
            false: 'N'
          },
          pinned: 'right'
        }, // Radio Button
        { field: 'totalOver', hide: true },
        {
          field: 'image',
          maxWidth: 80,
          cellRenderer: (params) => `<img style="height: 20px; width: 20px; border: 1px solid;" src=${params.data.imageSrc} />`,
          pinned: 'right'
        }, // Image
        { field: 'gold' },
        { field: 'silver' },
        { field: 'bronze' },
        { field: 'total' }
      ],
      defaultColDef: {
        minWidth: 80,
        filter: false,
        resizable: true,
        sortable: false
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid column 정의에 column 에 설정',
        ' */',
        '{',
        '\theaderName: \'Country (Combo List)\',',
        '\tfield: \'country\',',
        '\tminWidth: 150,',
        '\teditable: true,',
        '\tcellEditor: \'agSelectCellEditor\', // Combo List 설정',
        '\tcellEditorParams: {',
        '\t\tvalues: [\'United States\', \'Russia\', \'Australia\', \'Canada\', \'China\'] // Combo List에 표시될 value list',
        '\t}',
        '}, // Combo List',
        '{',
        '\theaderName: \'Button (Button Render)\',',
        '\tfield: \'button\',',
        '\twidth: 150,',
        '\tcellRenderer: \'buttonRenderer\', // Custom Cell Button 설정',
        '\tcellRendererParams: {',
        '\t\tclicked: function (params) {',
        '\t\t\tself.cellButtonClicked(params)',
        '\t\t}, // button click event 설정',
        '\t\tbtnType: \'is-light\',',
        '\t\tbtnIcon: \'cursor-default-click\', // button icon 설정',
        '\t\tbtnTitle: \'Button Render\', // button title 설정',
        '\t\tbtnStyle: \'height: 20px;\', // button 추가 style 설정',
        '\t\tbtnLabel: \'Button Render\' // button text 설정',
        '\t}',
        '}, // Button',
        '{',
        '\theaderName: \'Total Five Over (Check Box)\',',
        '\tfield: \'totalFiveOver\',',
        '\ttype: \'checkboxColumn\', // Check Box Column Type 지정',
        '\tdataMapping: {',
        '\t\tkey: \'totalOver\', // Check Box 기반 data',
        '\t\ttrue: \'Y\', // Check Box가 checked일 때 값 mapping',
        '\t\tfalse: \'N\' // Check Box가 checked가 아닐 때 값 mapping',
        '\t}',
        '}, // Check Box',
        '{',
        '\theaderName: \'Total Five Over (Radio Button)\',',
        '\tfield: \'totalFiveOver\',',
        '\ttype: \'radioButtonColumn\',',
        '\tdataMapping: {',
        '\t\tkey: \'totalOver\', // Radio Button 기반 data',
        '\t\ttrue: \'Y\', // 값 mapping (추후 값 추가 등 수정 필요)',
        '\t\tfalse: \'N\' // 값 mapping (추후 값 추가 등 수정 필요)',
        '\t}',
        '}, // Radio Button',
        '{ field: \'totalOver\', hide: true },',
        '{',
        '\tfield: \'image\',',
        '\tmaxWidth: 80,',
        '\t// Cell Renderer 설정으로 cell 위에 image tag를 올림',
        // eslint-disable-next-line no-template-curly-in-string
        '\tcellRenderer: (params) => `<img style="height: 20px; width: 20px; border: 1px solid;" src=${params.data.imageSrc} />`',
        '} // Image'
      ].join('\n')
    }
  }
}
</script>

<style lang="scss">
  .fdc-panel {
    .panel-body {
      padding: 10px;
    }
  }
</style>
